import type {
  AddToastHandler,
  AlertHandles,
  AlertRegistryApi,
  ToastOptions
} from './alerts.types';

let addToastHandler: AddToastHandler | undefined;

export const AlertRegistry: AlertRegistryApi = {
  showUnauthorizedModal: undefined,
  showMultipleErrorModal: undefined,

  /** Always-callable toast entry point; forwards to the registered handler. */
  addToast: (toast: ToastOptions) => {
    addToastHandler?.(toast);
  },

  /**
   * Register alert implementations. Only the keys present in
   * `overrides` are updated, so components can register independently as they
   * mount.
   */
  configure(overrides: Partial<AlertHandles>): void {
    if ('addToast' in overrides) {
      addToastHandler = overrides.addToast;
    }
    if ('showUnauthorizedModal' in overrides) {
      this.showUnauthorizedModal = overrides.showUnauthorizedModal;
    }
    if ('showMultipleErrorModal' in overrides) {
      this.showMultipleErrorModal = overrides.showMultipleErrorModal;
    }
  },

  /** Reset all handlers to their unregistered state. Primarily useful in tests. */
  reset(): void {
    addToastHandler = undefined;
    this.showUnauthorizedModal = undefined;
    this.showMultipleErrorModal = undefined;
  }
};
